/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PageContentContainer from './../../components/PageContentContainer/PageContentContainer';
import { AdminInput, Alerts, Spinner } from "@project/components";
import BtnPrime from "../../components/BtnPrime/BtnPrime";
import TitleDescription from "../../components/TitleDescription/TitleDescription";
import { useLocation, useNavigate } from 'react-router-dom';
import { isValidPhone } from './../../utils/utils';
import axios from '../../utils/axios';
import { useIntl } from 'react-intl';

const classNames = require('classnames');

const Invitations = () => {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({id});

  const navigate = useNavigate();

  const query = new URLSearchParams(useLocation().search);

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [token, setToken] = useState(null);
  // const [invite, setInvite] = useState({});
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [cpassword, setCPassword] = useState('');
  const [email, setEmail] = useState('');
  const [fname, setFname] = useState('');
  const [lname, setLname] = useState('');
  const [phone, setPhone] = useState('');
  const [useMfa, setUseMfa] = useState(true);

  // validate invitation exists and is active
  useEffect(() => {
    setLoading(false);
    setErrors([]);

    const val = async () => {

      try {
        setLoading(true);

        let result = await axios.post(`/validate-invite`, { token });
        if (result.status === 200) {
          // setInvite(result.data.invite);
          setEmail(result.data.invite.email);
          setUsername(result.data.invite.email);
        }

      } catch (e) {
        if (e.response && e.response.data) {
          setErrors([`${t('error.sendInvite')} (${e.response.data.errors})`]);
        } else {
          setErrors([(e && e.message) || t('error.server')]);
        }
      }
      finally {
        setLoading(false);
      }
    };

    if (token) val()

  }, [token]);

  useEffect(() => {
    const t = query.get("t");
    if (t) setToken(t);
  }, []);

  const registerUser = async () => {
    setLoading(false);
    setErrors([]);

    try {
      setLoading(true);

      let errs = [];

      if (password !== cpassword) errs.push(t('error.password.match'));
      if (password.trim().length < 10) errs.push(t('error.password.length'));
      if (fname.trim().length < 1) errs.push(t('error.firstName.empty'));
      if (lname.trim().length < 1) errs.push(t('error.lastName.empty'));

      if (phone) {
        const tmpph = isValidPhone(phone);
        if (!tmpph) errs.push(t('error.phone.invalid'));
      }

      if (errs.length > 0) {
        return setErrors(errs);
      }

      const postobj = {
        token,
        username,
        email,
        fname,
        lname,
        password,
        phone,
        useMfa
      };

      let result = await axios.post(`/redeem-invitation`, postobj);

      if (result.status === 200) {
        navigate(`login`);
      }

    } catch (e) {
      if (e.response && e.response.data) {
        setErrors(e.response.data.errors.map(err => err.message))
      } else {
        setErrors((e && e.message) || t('error.server'));
      }
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageContentContainer>

        <div style={{ width: '100vw', marginLeft: '15vw'}}>
          <div style={{width: '70vw'}}>

            {errors.length > 0 ?
              <div style={{ "marginTop": "20px" }}><Alerts messages={errors} close={() => setErrors([])} /></div>
              : null}

            <div className="d-flex justify-content-between align-items-center">
              <h3 className={classNames('font26')}>
                {t('Invitations.mainTitle')}
                <TitleDescription
                  title={t('Invitations.title')}
                  description={''}
                />
              </h3>
              <BtnPrime title={t('Invitations.complete')} onClick={registerUser} />
            </div>

            <div>
              <form>
                <AdminInput
                  label={t('Invitations.email')}
                  type="email"
                  placeholder={t('Invitations.email.placeholder')}
                  value={email}
                  readOnly={true} />

                <AdminInput
                  label={t('Invitations.username')}
                  type="text"
                  placeholder={t('Invitations.username.placeholder')}
                  value={username}
                  onChange={e => setUsername(e.target.value)} />

                <AdminInput
                  label={t('Invitations.password')}
                  type="password"
                  placeholder={t('Invitations.password.placeholder')}
                  value={password}
                  onChange={e => setPassword(e.target.value)} />

                <AdminInput
                  label={t('Invitations.confirmPassword')}
                  type="password"
                  placeholder={t('Invitations.confirmPassword')}
                  value={cpassword}
                  onChange={e => setCPassword(e.target.value)} />

                <AdminInput
                  label={t('Invitations.firstName')}
                  type="text"
                  placeholder={t('Invitations.firstName.placeholder')}
                  value={fname}
                  onChange={e => setFname(e.target.value)} />

                <AdminInput
                  label={t('Invitations.lastName')}
                  type="text"
                  placeholder={t('Invitations.lastName.placeholder')}
                  value={lname}
                  onChange={e => setLname(e.target.value)} />

                <AdminInput
                  label={t('Invitations.phone')}
                  type="text"
                  placeholder={t('Invitations.phone.placeholder')}
                  value={phone}
                  onChange={e => setPhone(e.target.value)} />

                <AdminInput
                  id='useMfa'
                  label={t('Invitations.mfa')}
                  type='checkbox'
                  checked={useMfa}
                  onChange={(e) => setUseMfa(e.currentTarget.checked)} />
              </form>
            </div>

          </div>
        </div>

      </PageContentContainer>

      {loading ?
        <Spinner />
        : null
      }
    </>
  );
};

export default Invitations;
